import {Dispatch, SetStateAction, useState} from "react";

export interface ObjectType {
    [key: string]: any;
}

export interface UseModal {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;

    toggleIsOpen(): void;

    onClose(): void;

    onOpen(payload?: ObjectType): void;

    payload?: ObjectType;
}

export const useModal = (isDefaultOpen?: boolean): UseModal => {
    const [isOpen, setIsOpen] = useState<boolean>(!!isDefaultOpen);
    const [modalPayload, setModalPayload] = useState<ObjectType>();

    const toggleIsOpen = () => {
        setIsOpen((prev) => !prev);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const onOpen = (payload: ObjectType) => {
        setIsOpen(true);
        if (payload) {
            setModalPayload(payload);
        }
    };

    return {
        isOpen,
        setIsOpen,
        toggleIsOpen,
        onClose,
        onOpen,
        payload: modalPayload,
    };
};
